import { Button } from '@onchainstudios/cryptoys-common-ui';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { deleteReservation } from '../../lib/cryptoys/drops/reservation';
import StatusPage from '../../components/StatusPage';
import { getLegionImage, resetReservation } from '../../utils';
import JunoPonder from '../../img/zoo/JunoPonder.webp';

function TransientError() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    document.title = 'Cryptoys - Error';
    // Cancel the current reservation to make inventory available
    const id = searchParams.get('reservationId');
    if (id) {
      deleteReservation(id, searchParams.get('correlationId'));
    }
    //  We only want this to run once after the page loads
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StatusPage
      waveColor="red"
      legionImage={getLegionImage('transientError') ?? JunoPonder}
      contentHeading="Sorry! Something Went Wrong..."
      contentHeadingTag={
        <span>
          We’re not sure what went wrong, but we’re working to identify and fix
          the problem! Please try again shortly.
        </span>
      }
      buttonCont={
        <Button
          id="tryAgainButton"
          data-testid="retry-button"
          size="large"
          onPress={() => {
            resetReservation(searchParams.get('dropId'));
          }}
        >
          Try Again
        </Button>
      }
    />
  );
}

export default TransientError;
